import Footer from "../components/Footer"
import Navbar from "../components/Navbar";


export default function Privacy() {
    return (
        <div className="text-black">
            <Navbar/>
            <div className="max-w-3xl mx-auto mt-8 mb-8">
            <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>

            <p className="mb-4">
                Ai sensi del Regolamento UE 2016/679 (GDPR), informiamo che i dati
                personali raccolti tramite questo sito sono trattati nel rispetto
                dei principi di liceità, correttezza e trasparenza.
            </p>

            <h2 className="text-xl font-semibold mt-4">Titolare del trattamento</h2>
            <p>Arena Championship</p>
            <p>Email: arenachampionship.event@gmail.com</p>

            <h2 className="text-xl font-semibold mt-4">Dati raccolti</h2>
            <ul className="list-disc ml-6">
                <li>Nome e cognome</li>
                <li>Email</li>
                <li>Telefono</li>
                <li>Dati sportivi (peso, categoria, esperienza)</li>
                <li>Certificato medico</li>
                <li>Messaggi inviati tramite form</li>
            </ul>

            <h2 className="text-xl font-semibold mt-4">Finalità</h2>
            <p>
                I dati sono utilizzati per la gestione delle iscrizioni,
                organizzazione dell’evento e comunicazioni con gli utenti.
            </p>

            <h2 className="text-xl font-semibold mt-4">Base giuridica</h2>
            <p>Il trattamento avviene sulla base del consenso dell’utente.</p>

            <h2 className="text-xl font-semibold mt-4">Conservazione</h2>
            <p>
                I dati saranno conservati per il tempo necessario alla gestione
                dell’evento e per eventuali obblighi legali.
            </p>

            <h2 className="text-xl font-semibold mt-4">Diritti</h2>
            <p>
                L’utente può richiedere accesso, modifica o cancellazione dei dati
                scrivendo all’email indicata.
            </p>
            </div>
            <Footer/>
        </div>
    );
}